import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for groups hooks
 * Keys match backend controller method names
 */
export const groupsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["groups", "findAll", params] as const)
      : (["groups", "findAll"] as const),
  findOne: (groupUuid: string) => ["groups", "findOne", groupUuid] as const,
} as const

/**
 * Query key utilities for group dues hooks
 */
export const groupDuesKeys = {
  getDues: (groupUuid: string) => ["groups", "getDues", groupUuid] as const,
} as const
